import styled from '@emotion/styled'
import {
  InfoLarge500Style,
  InfoXXXLarge500Style,
  InfoMedium500Style,
} from '../../styles/Text.styles'
import { css } from '@emotion/react'
import theme from '../../styles/theme'

export const HeaderContainer = styled.div`
  background-color: ${`${theme.colors.primary}A0`};
  border-radius: 1rem;
  padding: 2rem 2rem 0rem 2rem;
  margin-bottom: 1rem;
`

// Custom HStack component for horizontal stacking
export const HStack = styled.div`
  display: flex;
  align-items: center;
  gap: '10px';
`

export const WrapHStack = styled.div`
  display: flex;
  flex-wrap: wrap;
  gap: 1rem;
  align-items: center;
  justify-content: center;
  width: 100%;
`

export const HeaderTop = styled(HStack)`
  justify-content: space-between;
  width: 100%;
  margin-bottom: 3rem;
`

export const TitleContainer = styled.div`
  display: inline-flex;
  align-items: center;
  gap: 1rem;
  margin-bottom: 0;
  padding-left: 0.3rem;
  width: auto;
  min-width: min-content;
`

export const TitleText = styled.span`
  ${InfoXXXLarge500Style};
  display: inline-block;
`

export const ValueInfoBigStyle = css`
  ${InfoXXXLarge500Style};
`

export const ValueInfoNormalStyle = css`
  ${InfoLarge500Style};
  word-break: keep-all;
  overflow-wrap: normal;
`

export const ValueInfoMediumStyle = css`
  ${InfoMedium500Style};
  word-break: keep-all;
  overflow-wrap: normal;
`
